export const EmptyPolygonStyle = {
    weight: 1,
    fillOpacity: 0,
    color: 'black',
};

export const DefaultPolygonStyle = {
    weight: 1,
    fillOpacity: 0.9,
    color: 'black',
};

export const HatchImage = '/assets/img/hatch-pattern.png';

// For some reason these colors are not part of the color palette
export const MapColors = {
    red: '#d7191c',
    orange: '#f69053',
    yellow: '#ffdf9a',
    paleGreen: '#dcf09e',
    lightGreen: '#8acc62',
    green: '#1a9641',
};

// For some reason these colors are not part of the color palette
export const MapColorsAlt = {
    darkGreen: '#225431',
    lightGreen: '#77c35c',
    lighterGreen: '#c4e687',
    paleGreen: '#ffffc0',
};
